import { useRef } from "react"
import {
	IconMagnifierOutline18 as SearchIcon,
	IconXmarkOutline18 as XIcon,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { IconButton, Input } from "@productlane/ui"

export function MemberSearch({
	value,
	onChange,
}: {
	value: string
	onChange: (value: string) => void
}) {
	const inputRef = useRef<HTMLInputElement>(null)

	return (
		<div className="flex flex-1 items-center gap-2 rounded-lg border border-gray-200 px-2.5 dark:border-gray-700/80">
			<SearchIcon className="h-4 w-4 flex-none text-secondary" />
			<Input
				ref={inputRef}
				variant="borderless"
				textSize="sm"
				placeholder="Search by name or email"
				value={value}
				name="member-search"
				className="px-0 placeholder:text-tertiary"
				inputClassName="h-8"
				onChange={(e) => onChange(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Escape" && value) {
						e.preventDefault()
						e.stopPropagation()
						onChange("")
					}
				}}
			/>
			<IconButton
				Icon={XIcon}
				variant="subtle"
				size="md"
				aria-label="Clear search"
				iconClassName="h-3.5 w-3.5"
				className={cn("-mr-1 flex-none", !value && "invisible")}
				onClick={() => {
					onChange("")
					inputRef.current?.focus()
				}}
			/>
		</div>
	)
}
